import React from 'react';
import { FiGithub, FiLinkedin, FiTwitter, FiHeart, FiMail } from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const socialLinks = [
    { icon: <FiGithub />, href: 'https://github.com/Gayatrii4506', label: 'GitHub' },
    { icon: <FiLinkedin />, href: 'https://www.linkedin.com/in/gayatri-duse/', label: 'LinkedIn' },
    { icon: <FiMail />, href: 'mailto:gayatriduse99@gmail.com', label: 'Gmail' },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <a href="#home" className="footer-logo">
            <span className="footer-logo-text">GD</span>
            <span className="footer-logo-dot">.</span>
          </a>
          <div className="footer-social">
            {socialLinks.map((link, i) => (
              <a
                key={i}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label={link.label}
              >
                {link.icon}
              </a>
            ))}
          </div>
        </div>
        <div className="footer-divider"></div>
        <div className="footer-bottom">
          <p className="footer-copy">
            &copy; {new Date().getFullYear()} Gayatri Duse. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;